import React from "react";
import { object } from "prop-types";

import ComponentContainer from "../../layouts/component-container";
import Organism from "./Organism";
import CustomSlider from "../../atoms/CustomSlider";

import { useDevice } from "../../utils/react-utils";

import "./numberedSliderStories.m.css";

const NumberedSliderStories = ({ collection }) => {
  if (!collection?.items?.length) return null;

  const { mobile } = useDevice();

  const {
    items,
    "associated-metadata": { number_of_stories_to_show: storiesToShow = 5, enable_auto_play: autoplay = false },
  } = collection;

  const stories = items.reduce((accumulator, item) => {
    if (item.type === "story") {
      accumulator.push(item.story);
    }
    return accumulator;
  }, []);

  if (!stories.length) return null;

  const storyList = stories.slice(0, storiesToShow);

  return (
    <ComponentContainer collection={collection}>
      <div styleName="wrapper">
        <CustomSlider
          isNavigation={!mobile && storyList.length > 1}
          isAutoplay={autoplay}
          slidesPerView={{ mobileSlides: 1, tabSlides: 1, desktopSlides: 1 }}
          spacing={{ mobileSpace: 12, tabSpace: 12, desktopSpace: 12 }}
        >
          {storyList.map((story, index) => (
            <Organism key={index} story={story} headlineNumber={index + 1} />
          ))}
        </CustomSlider>
      </div>
    </ComponentContainer>
  );
};

NumberedSliderStories.propTypes = {
  collection: object.isRequired,
};

NumberedSliderStories.storyLimit = 10;

export default NumberedSliderStories;
